import { ApiFunc, getInstance, getNotAuthInstance } from '@helpers/httpClient'
import { prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const inquiryAll: ApiFunc<`${typeof API.INQUIRY_ALL}`, 'get'> = data =>
  instance.get(API.INQUIRY_ALL, { params: data })

export const inquiryCreate: ApiFunc<`${typeof API.INQUIRY_CREATE}`, 'post'> = data =>
  instance.post(API.INQUIRY_CREATE, data)

export const inquiryList: ApiFunc<`${typeof API.INQUIRY}`, 'get'> = data => instance.get(API.INQUIRY, { params: data })

export const inquiryAssigned: ApiFunc<`${typeof API.INQUIRY_ASSIGNED}`, 'get'> = data =>
  instance.get(API.INQUIRY_ASSIGNED, { params: data })

export const inquiryItemDelete: ApiFunc<`${typeof API.INQUIRY}{id}`, 'delete'> = data =>
  instance.delete(`${API.INQUIRY}${'id' in data ? prop('id', data) : prop('name', data)}`)

export const inquiryItem: ApiFunc<`${typeof API.INQUIRY}{id}`, 'get'> = data =>
  instance.get(`${API.INQUIRY}${'id' in data ? prop('id', data) : prop('name', data)}`)

export const inquiryUpdateStatus: ApiFunc<`${typeof API.INQUIRY_UPDATE_STATUS}`, 'post'> = data =>
  instance.post(API.INQUIRY_UPDATE_STATUS, data)

export const inquiryComments: ApiFunc<`${typeof API.INQUIRY_COMMENT}`, 'get'> = () => instance.get(API.INQUIRY_COMMENT)

export const inquiryCommentCreate: ApiFunc<`${typeof API.INQUIRY_COMMENT}`, 'post'> = data =>
  instance.post(API.INQUIRY_COMMENT, data)

export const inquiryCommentDelete: ApiFunc<`${typeof API.INQUIRY_COMMENT}{id}`, 'delete'> = data =>
  instance.delete(`${API.INQUIRY_COMMENT}${'id' in data ? prop('id', data) : prop('name', data)}`)

export const inquiryPublicInfo: ApiFunc<`${typeof API.INQUIRY_PUBLIC_INFO}`, 'get'> = data =>
  getNotAuthInstance().get(API.INQUIRY_PUBLIC_INFO, { params: data })
